/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementary`)
};

const es_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementaria`)
};

const de_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplementär`)
};

const nl_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementair`)
};

const fr_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complémentaire`)
};

const it_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementare`)
};

const pt_br2_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementar`)
};

const pt_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementar`)
};

const ja_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`補色`)
};

const zh_cp_complementary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`互补色`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_complementary = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_complementary(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_complementary", locale)
	if (locale === "en") return en_cp_complementary(inputs)
	if (locale === "es") return es_cp_complementary(inputs)
	if (locale === "de") return de_cp_complementary(inputs)
	if (locale === "nl") return nl_cp_complementary(inputs)
	if (locale === "fr") return fr_cp_complementary(inputs)
	if (locale === "it") return it_cp_complementary(inputs)
	if (locale === "pt-BR") return pt_br2_cp_complementary(inputs)
	if (locale === "pt") return pt_cp_complementary(inputs)
	if (locale === "ja") return ja_cp_complementary(inputs)
	return zh_cp_complementary(inputs)
};